import configData from '../../config.json';
import axios from 'axios';
import { Decrypt } from '../Helper';

export const GetUser = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `users/get`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) { 
            return error;
        });
}

export const GetUserByEmail = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `users/getUserByEmail`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const PermanentDeleteUser = async (id) => {
    var config = {
        method: 'delete',
        url: configData.API_ENDPOINT + `users/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
    };
    return axios(config)
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    }
    );
}

export const GetUserById = async (id) => {
    var config = {
        method: 'get',
        url: configData.API_ENDPOINT + `users/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        // data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const UpdateUser = async (v, id) => {
    var config = {
        method: 'put',
        url: configData.API_ENDPOINT + `users/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}
export const EnableUser = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `users/enableUser`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}
export const CreateUser = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `users`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}
export const GetRole = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `roles/get`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}
export const DeleteUser = async (id) => {
    var config = {
        method: 'delete',
        url: configData.API_ENDPOINT + `users/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        // data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}     